import {
    Modal,
    append,
    stripDate,
    show,
    makeElement,
    $
} from './utils';
import { iBook, iBookData } from './types/interfaces';

const modal = new Modal();

class Book implements iBook {

    public isbn?: string;
    public price?: number;
    public payhip?: {
        print: string,
        ebook: string
    };
    public bookshop?: string;
    public overdrive?: string;
    public b2r?: string;
    public bookBub?: string;
    public goodreads?: string;

    private today = stripDate();
    private _pubDate: Date = this.today;
    public get pubDate(): Date {
        return this._pubDate;
    }
    private set pubDate(value: Date | number | string | undefined) {
        if (!!value) { this._pubDate = stripDate(value); }
    }

    private _preOrderDate = this.today;
    public get preOrderDate(): Date {
        return this._preOrderDate;
    }
    public set preOrderDate(value: Date | number | string | undefined) {
        if (!!value) { this._preOrderDate = stripDate(value); }
    }

    public get preOrder(): boolean {
        return this.comingSoon && (this.preOrderDate <= this.today);
    }
    public get comingSoon(): boolean {
        return (this.today < this.pubDate);
    };
    public outOfStock = false;

    constructor (bookData: iBookData) {

        if (bookData != <iBookData>{}) {
            Object.assign(this, bookData as iBookData);
        }
        if (!bookData.preOrderDate && !!window.preOrderDate) {
            this.preOrderDate = stripDate(window.preOrderDate);
        }
        if (!bookData.pubDate && !!window.preOrderDate) {
            this.pubDate = stripDate(window.preOrderDate);
        }
    }
}

function updateBookDisplay(book: Book) {

    // update pubDate
    const $pubDate = $('#pubDate');
    if (!!$pubDate) {
        $pubDate.innerHTML = new Intl.DateTimeFormat(undefined, {month: 'long', year: 'numeric'}).format(book.pubDate);
    }

    // update pubDateLabel
    let pbLabelText = book.preOrder ? "Pre-Order Until" : ( (book.comingSoon) ? "Coming": null );
    if (!!pbLabelText) {
        const $pubDateLabel = $('#pubDateLabel');
        if (!!$pubDateLabel) { $pubDateLabel.innerHTML = `${pbLabelText}:`; }
    }

    // update book's primary retail price
    // TODO: add ebook & print pricing
    if (!!book.price) {
        const $priceLabel = $('div.links .price');
        if(!!$priceLabel) { $priceLabel.innerHTML = '$'+book.price; }
    }

    // add book's ISBN
    // TODO: add ebook and print ISBNs
    if (!!book.isbn) {
        const $bookDetails = $('.book .details');
        append($bookDetails, `<br><b>ISBN:</b> ${book.isbn}`);
    }

    // update purchase actions
    const $directHeader = $('h6.direct');
    if (book.comingSoon && !!$directHeader) {
        // COMING SOON
        $directHeader.innerHTML = "Coming Soon!";
        show($directHeader);
    } else {
        // AVAILABLE NOW
        let $indirectHeader = $('h6.indirect');
        // show BUY buttons if book is available for sale or pre-order

        if (!!book.payhip) {
            show($directHeader);
            const $directActions = $('ul.actions.direct');
            if (!!book.payhip.print) {
                if ($directActions?.classList.contains('outofstock')) {
                    append($directActions, `<li><a href="https://matthewrasnake.com/waitlist/${book.isbn?.replace(/\-/g,'')}" class="button primary fit">Join Waitlist!</a></li>`);
                } else {
                    append($directActions, `<li><a href="https://.com/${book.payhip.print}" class="button primary fit payhip-buy-button" data-theme="none" data-product="${book.payhip.print}">${(book.preOrder ? "Preorder" : "Buy")} Print</a></li>`);
                }
            }
            if (!!book.payhip.ebook) {
                    append($directActions, `<li><a href="https://.com/${book.payhip.ebook}" class="button primary fit payhip-buy-button" data-theme="none" data-product="${book.payhip.ebook}">${(book.preOrder ? "Preorder" : "Buy")} eBook</a></li>`);
            }
            let phScript = makeElement({
                elementName: `script`,
                attributes: [
                    {type: `text/javascript`},
                    {src: `https://payhip.com/payhip.js?v=24u69003`}
                ]
            });
            $('body')?.appendChild(phScript);
        }
        if (!!book.bookshop || !!book.overdrive || !!book.b2r) {
            show($indirectHeader);
            const $indirectActions = $('ul.actions.indirect');
            if (!!book.bookshop) {
                append($indirectActions, `<li><a href="https://bookshop.org/a/16912/${book.bookshop}" class="button fit" title="Find your local bookstore on Bookshop.org">Your Local Bookstore</a></li>`);
            }
            if (!!book.overdrive) {
                append($indirectActions, `<li><a href="https://www.overdrive.com/media/${book.overdrive}" class="button fit overdrive" title="Borrow from your local library on Overdrive.com">Your Local Library</a></li>`);
                $<HTMLAnchorElement>('.button.overdrive')?.addEventListener('click', e => {
                    e.preventDefault();
                    let odURL: string;
                    if (odURL = (e.currentTarget as HTMLAnchorElement).href) {
                        $('#odLink')?.setAttribute('href', odURL);
                    };
                    let modalContent = $('.modal-content.overdrive')?.innerHTML;
                    if (!!modalContent) { modal.show("Library Availability", modalContent) };
                });
            }
            if (!!book.b2r) {
                append($indirectActions, `<li><a href="https://books2read.com/${book.b2r}" class="button fit" title="Choose your favorite online retailer">The Big Guys</a></li>`);
            }
        }
        if (!!book.goodreads || !!book.bookBub) {
            show($('h6.book-love'));
            const $bookLoveActions = $('ul.actions.book-love');
            if (!!book.goodreads) {
                append($bookLoveActions, `<li><a href="https://www.goodreads.com/book/show/${book.goodreads}" target="_blank"><img src="https://s.gr-assets.com/assets/badge/goodreads-badge-add-plus-71eae69ca0307d077df66a58ec068898.png" height="41"></a></li>`);
            }
            if (!!book.bookBub) {
                append($bookLoveActions, `<li><a href="https://www.bookbub.com/books/${book.bookBub}" target="_blank"><img src="https://images.matthewrasnake.com/logo_BookBub.jpg" height="41"></a></li>`);
            }
        }
    }
}

if (!!window.bookData) {
    let book = new Book(window.bookData as iBookData);
    !!book && document.addEventListener("DOMContentLoaded", updateBookDisplay.bind(globalThis, book));
}
